import React, { useEffect, useState } from 'react';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Col, Row } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import Spinner from 'react-bootstrap/Spinner';
import * as apiUtility from "../../config/APIUtils";
import { Divider, IconButton, Paper, Tooltip, Box, Typography } from "@mui/material";
import * as XLSX from "xlsx";
import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import ErrorPopUp from '../Utility/ErrorPopUp';
import { RiFileExcel2Line } from "react-icons/ri";
import { BsFiletypePdf } from "react-icons/bs";
import { Button, Sheet } from '@mui/joy';

function HomeStaffSummary(props) {
    const [staffRoleID, setStaffRoleID] = useState(props.roleId || "");
    const [homeStaffDataFinal, setHomeStaffDataFinal] = useState([]);
    const [showSpinner, setshowSpinner] = useState(false);
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [dataForErrorPopup, setDataForErrorPopup] = useState('');

    var homeID = props.homeId;
    var filterObj = props.filterBy;
    var staffFlag = props.staffFlag;
    var crsPolicyType = props.crsPolicyType;

    const fetchHomeStaffData = async () => {
        if (homeID === undefined || homeID === null) return;
        setshowSpinner(true);
        try {
            setStaffRoleID(props.roleId || "");
            const body = {
                homeId: homeID,
                firstName: filterObj?.firstName || "",
                lastName: filterObj?.lastName || "",
                staffFlag: staffFlag,
                crsPolicyType:crsPolicyType
            };
            const apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = "audit-report/home-staff-summary";
            apiRequest.data = body;
            const res = await apiUtility.sendAPIDataPOST(apiRequest);
            setHomeStaffDataFinal(Array.isArray(res.data) ? res.data : []);
        } catch (error) {
            console.error("Error fetching home staff summary:", error);
            setDataForErrorPopup("Unable to fetch home staff data. Please try again.");
            setShowErrorPopup(true);
            setHomeStaffDataFinal([]);
        } finally {
            setshowSpinner(false);
        }
    };

    useEffect(() => {
        let mounted = true;
        if (mounted) fetchHomeStaffData();
        return () => {
            mounted = false;
        };

        
    }, [homeID, JSON.stringify(filterObj), staffFlag, props.roleId]);

    var filteredHomeStaffData = Array.isArray(homeStaffDataFinal)
        ? homeStaffDataFinal.filter((val) => {
            if (staffRoleID === "" || staffRoleID === "0" || staffRoleID === 0) return true;
            return String(staffRoleID) === String(val.role_id);
        })
        : [];

     const headerStyleElement = {
            position: 'sticky',
            top: 0,
            backgroundColor: '#ffffff', 
            borderBottom: '1px solid #016594', 
            zIndex: 1   ,
            
        }

    var homeStaffCols = [{
        dataField: 'role_id',
        sort: true,
        text: 'Role ID',
        headerStyle: headerStyleElement
    }, {
        dataField: 'role_name',
        sort: true,
        text: 'Role Name',
        headerStyle: headerStyleElement
    }
        , {
        dataField: 'user_id',
        sort: true,
        text: 'User ID',
        headerStyle: headerStyleElement
    }, {
        dataField: 'first_name',
        sort: true,
        text: 'First Name',
        headerStyle: headerStyleElement
    }, {
        dataField: 'last_name',
        sort: true,
        text: 'Last Name',
        headerStyle: headerStyleElement
    }
        , {
        dataField: 'status',
        sort: true,
        text: 'Status',
        headerStyle: headerStyleElement
    },
        , {
        dataField: 'is_complaint',
        sort: true,
        text: 'Is Course Compliant ?',
        headerStyle: headerStyleElement
    }
    ];

    if (props.crsPolicyType=='11') {
        homeStaffCols.push({
        dataField: 'is_policy_complaint',
        sort: true,
        text: 'Is Home Doc Compliant ?'
    });
    }
    if (props.crsPolicyType=='10') {
        homeStaffCols.splice(7, 1);
        homeStaffCols.push({
        dataField: 'is_policy_complaint',
        sort: true,
        text: 'Is Home Doc Compliant ?'
    });
    }


    var exportHomeDefPDF = () => {
        const unit = "pt";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "portrait"; // portrait or landscape

        const marginLeft = 5;
        const doc = new jsPDF(orientation, unit, size);

        doc.setFontSize(15);

        const title = "LCPT - Home Staff Report";
        var headers;
        var dataArr;

        if(crsPolicyType=='9'){
         headers = [["Role ID", "Role Name", "User ID", "First Name", "Last Name", "Status", "Course Compliant"]];

        let dataArr = [];

        for (let i = 0; i < filteredHomeStaffData.length; i++) {
            var tempArr = [filteredHomeStaffData[i]["role_id"], filteredHomeStaffData[i]["role_name"], filteredHomeStaffData[i]["user_id"],
            filteredHomeStaffData[i]["first_name"], filteredHomeStaffData[i]["last_name"], filteredHomeStaffData[i]["status"], filteredHomeStaffData[i]["is_complaint"]];

            dataArr.push(tempArr);


        }
        }
        else if(crsPolicyType=='10'){
         headers = [["Role ID", "Role Name", "User ID", "First Name", "Last Name", "Status", "Home Doc Compliant"]];

         dataArr = [];

        for (let i = 0; i < filteredHomeStaffData.length; i++) {
            var tempArr = [filteredHomeStaffData[i]["role_id"], filteredHomeStaffData[i]["role_name"], filteredHomeStaffData[i]["user_id"],
            filteredHomeStaffData[i]["first_name"], filteredHomeStaffData[i]["last_name"], filteredHomeStaffData[i]["status"], filteredHomeStaffData[i]["is_policy_complaint"]];

            dataArr.push(tempArr);


        }
        }
        else{
            
         headers = [["Role ID", "Role Name", "User ID", "First Name", "Last Name", "Status", "Course Compliant","Home Doc Compliant"]];

         dataArr = [];

        for (let i = 0; i < filteredHomeStaffData.length; i++) {
            var tempArr = [filteredHomeStaffData[i]["role_id"], filteredHomeStaffData[i]["role_name"], filteredHomeStaffData[i]["user_id"],
            filteredHomeStaffData[i]["first_name"], filteredHomeStaffData[i]["last_name"], filteredHomeStaffData[i]["status"], filteredHomeStaffData[i]["is_complaint"], filteredHomeStaffData[i]["is_policy_complaint"]];

            dataArr.push(tempArr);


        }
        }

      

        doc.setProperties({
            title: title,
            subject: 'Carepasport auto generated reports',
            author: 'LCPT',
            keywords: 'generated, javascript, web 2.0, ajax',
            creator: 'LCPT',
            bodyStyles: {
                color: '#cccccc'
            }
        });
        doc.text(title, 300, 40, {
            align: 'center'
        });
        let content = {
            startY: 50,
            head: headers,
            body: dataArr
        };

        autoTable(doc, content);
        let dateVar = new Date();
        let fileName = "Carepassport_HomeStaffSummary-" + dateVar.getDate() + dateVar.getMonth() + dateVar.getFullYear() + "_" + dateVar.getHours() + dateVar.getMinutes() + ".pdf";
        doc.save(fileName)
    }

    const workbook2blob = (workbook) => {
        const wopts = {
            bookType: "xlsx",
            bookSST: false,
            type: "binary",
        };
        const wbout = XLSX.write(workbook, wopts);
        const blob = new Blob([s2ab(wbout)], {
            type: "application/octet-stream",
        });
        return blob;
    };
    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; i++) {
            view[i] = s.charCodeAt(i);
        }
        return buf;
    }

    //Excel
    const exportInExcel = async () => {
        try {
            var rowsCount = 6;
            const title = [{ A: 'CarePassport - Staff Summary Report for Home ID : ' + String(homeID) }];
            let reportView = [{ A: 'Name', B: 'User ID', C: 'Role', D: 'Date' }];
            reportView.push({
                A: sessionStorage.getItem('fullName'),
                B: sessionStorage.getItem('userId'),
                C: (sessionStorage.getItem('userType') !== null) ? sessionStorage.getItem('userType').toUpperCase() : "User",
                D: new Date().toLocaleString()
            });
            reportView.push("");
            reportView.push("");
            var reportHeaders={};
            if(props.crsPolicyType=='9'){
             reportHeaders = { A: 'Role ID', B: 'Role Name', C: 'User ID', D: 'First Name', E: 'Last Name', F: 'Status', G: 'Is Course Compliant?' };
             reportView.push(reportHeaders);
            // orgStaffTemplateData.forEach(element => {
            filteredHomeStaffData.forEach(element => {
                rowsCount += 1;
                var tempObj = {
                    A: element.role_id,
                    B: element.role_name,
                    C: element.user_id,
                    D: element.first_name,
                    E: element.last_name,
                    F: element.status,
                    G: element.is_complaint
                };
                reportView.push(tempObj);
            });
            }
            else if(props.crsPolicyType=='10'){
             reportHeaders = { A: 'Role ID', B: 'Role Name', C: 'User ID', D: 'First Name', E: 'Last Name', F: 'Status', G: 'Is Home Doc Compliant?' };
             reportView.push(reportHeaders);
            // orgStaffTemplateData.forEach(element => {
            filteredHomeStaffData.forEach(element => {
                rowsCount += 1;
                var tempObj = {
                    A: element.role_id,
                    B: element.role_name,
                    C: element.user_id,
                    D: element.first_name,
                    E: element.last_name,
                    F: element.status,
                    G: element.is_policy_complaint
                };
                reportView.push(tempObj);
            });
            }
            else{
            reportHeaders = { A: 'Role ID', B: 'Role Name', C: 'User ID', D: 'First Name', E: 'Last Name', F: 'Status', G: 'Is Course Compliant?',H: 'Is Home Doc Compliant?' };
            reportView.push(reportHeaders);
            // orgStaffTemplateData.forEach(element => {
            filteredHomeStaffData.forEach(element => {
                rowsCount += 1;
                var tempObj = {
                    A: element.role_id,
                    B: element.role_name,
                    C: element.user_id,
                    D: element.first_name,
                    E: element.last_name,
                    F: element.status,
                    G: element.is_complaint,
                    H: element.is_policy_complaint
                };
                reportView.push(tempObj);
            });
            }
            
            const finalData = [...title, ...reportView];
            const worksheet = XLSX.utils.json_to_sheet(finalData, {
                skipHeader: true,
            });
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Home Staff Summary");
            const workbookblob = workbook2blob(workbook);
            var headerIndexes = [];
            finalData.forEach((data, index) =>
                data["A"] === "Role ID" ? headerIndexes.push(index) : null
            );
            const dataInfo = {
                titleCell: "A2",
                titleRange: props.crsPolicyType=='11'? "A1:H1":"A1:G1",
                tbodyRange: `A7:G${finalData.length}`,
                uHeadRange: `A2:D2`,
                uBodyRange: `A3:D3`,
                theadRange:
                    headerIndexes?.length >= 1
                        ? `A${headerIndexes[0] + 1}:G${headerIndexes[0] + 1}`
                        : null,
                theadRange1:
                    headerIndexes?.length >= 2
                        ? `A${headerIndexes[1] + 1}:I${headerIndexes[1] + 1}`
                        : null,
                tFirstColumnRange:
                    headerIndexes?.length >= 1
                        ? `A${headerIndexes[0] + 1}:A${rowsCount + headerIndexes[0] + 1}`
                        : null,
                tLastColumnRange:
                    headerIndexes?.length >= 1
                        ? `K${headerIndexes[0] + 1}:I${rowsCount + headerIndexes[0] + 1}`
                        : null,

                tFirstColumnRange1:
                    headerIndexes?.length >= 1
                        ? `A${headerIndexes[1] + 1}:A${rowsCount + headerIndexes[1] + 1}`
                        : null,
                tLastColumnRange1:
                    headerIndexes?.length >= 1
                        ? `H${headerIndexes[0] + 1}:I${rowsCount + headerIndexes[1] + 1}`
                        : null,
            };
            XlsxPopulate.fromDataAsync(workbookblob).then((workbook) => {
                workbook.sheets().forEach((sheet) => {
                    sheet.column("A").width(15);
                    sheet.column("B").width(30);
                    sheet.column("C").width(20);
                    sheet.column("D").width(30);
                    sheet.column("E").width(30);
                    sheet.column("F").width(20);
                    sheet.column("G").width(20);
                    if(props.crsPolicyType=='11'){
                    sheet.column("H").width(20);
                    }
                    sheet.range(dataInfo.titleRange).merged(true).style({
                        bold: true,
                        fontFamily: "Arial",
                        horizontalAlignment: "center",
                        verticalAlignment: "center",
                    });
                    sheet.range(dataInfo.uHeadRange).style({
                        fill: "A6A6A6",
                        bold: true,
                        horizontalAlignment: "center",
                    });
                    sheet.range(dataInfo.uBodyRange).style({
                        bold: true,
                        horizontalAlignment: "center",
                    });
                    if (dataInfo.tbodyRange) {
                        sheet.range(dataInfo.tbodyRange).style({
                            horizontalAlignment: "left",
                        });
                    }
                    sheet.range(dataInfo.theadRange).style({
                        fill: "A6A6A6",
                        bold: true,
                        horizontalAlignment: "center",
                    });
                    if (dataInfo.tFirstColumnRange) {
                        sheet.range(dataInfo.tFirstColumnRange).style({
                            bold: true,
                        });
                    }

                });

                return workbook.outputAsync().then((workbookBlob) => {
                    const downloadAnchorNode = document.createElement("a");
                    var dateVar = new Date();
                    var fileName = "Carepassport_HomeStaffSummary-" + dateVar.getDate() + dateVar.getMonth() + dateVar.getFullYear() + "_" + dateVar.getHours() + dateVar.getMinutes() + ".xlsx";
                    downloadAnchorNode.setAttribute("href", URL.createObjectURL(workbookBlob));
                    downloadAnchorNode.setAttribute("download", fileName);
                    downloadAnchorNode.click();
                    downloadAnchorNode.remove();
                    // setDataForSuccessPopup("Downloaded Successfully");
                    // setShowSuccessPopup(true);
                });
            });
        } catch (error) {
            setDataForErrorPopup("Something went wrong while processing excel!");
            setShowErrorPopup(true);
        }
    }

    const NoRowsOverlay = () => {
        return (
            <div className="text-center p-4">
            No records found for the selected date range.
            </div>
        );
        };

    const TABLE_CONTAINER_STYLE = {
        height: '700px',       
        overflowY: 'auto',     
        position: 'relative'   
    };

    return (
        
        <Box sx={{ position: 'relative', width: '100%' }}>
            {showSpinner && (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', top: 0, left: 0, right: 0, zIndex: 10, py: 2 }}>
                    <Spinner animation="border" size="lg" variant='primary' />
                </Box>
            )}
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                <Tooltip title="Export to Excel" variant="solid">
                    <Button
                        size="sm"
                        variant="outlined"
                        color="primary"
                        onClick={exportInExcel}
                    >                    
                        <RiFileExcel2Line fontSize={"1.5pc"}/>
                    </Button>
                </Tooltip>
            </Box>
            <Sheet variant="outlined" sx={{ borderRadius: "md" }} style={TABLE_CONTAINER_STYLE}>
                <BootstrapTable id='homeStaffSpecificTable' keyField='id' noDataIndication={NoRowsOverlay} data={filteredHomeStaffData} columns={homeStaffCols} striped hover />
            </Sheet>
            <ErrorPopUp show={showErrorPopup} data={dataForErrorPopup} onHide={() => { setShowErrorPopup(false) }} />
        </Box>
        
    )
}

export default HomeStaffSummary;